import moment from "moment";
import { get } from "lodash";
const RangeField = ({ source, record }) => {
  const range = get(record, source);
  return moment(range).format("MMMM YYYY");
};

export default RangeField;
